import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import CreditsUsageReportComponent from './CreditsUsageReportPage';

import { set } from '../../../store/actions/pages';
import { dateEquators, integerEquators, StringEquators } from '../../../store/constants/pages';
import { createCurrencyDataField, createIconDataField, createNumberDataField, createStringDataField, createTimestampField } from '../../../util/format';
import { createFilteredSortedDataSelector } from '../../../util/selector';
import { creditsUsageReportLanding, downloadCreditUsageReport, resetCreditUsageReport } from "../../../store/actions/creditUsage";
import { getEndDate, getStartDate } from "../../../util/date";

const DEFAULT_SORT = [{ id: 'userName', direction: 'asc' }];

const selectFields = createSelector(
    () => [
        createStringDataField('payerContract', 'Payer Contract', { sortable: true, equators: StringEquators, whiteSpace: 'break-spaces' }),
        createStringDataField('userName', 'User Name', { sortable: true, equators: StringEquators }),
        createStringDataField('userRole', 'User Role', { sortable: true, equators: StringEquators }),
        createStringDataField('processingType', 'Processing Type', { sortable: true, equators: StringEquators }),
        createNumberDataField('transectionCount', 'Transaction Count', { sortable: true, equators: integerEquators }),
        // createStringDataField('timestamp', 'Timestamp', { sortable: true, equators: StringEquators }),
        createTimestampField('timestamp', 'Timestamp', { sortable: true, equators: dateEquators }),
    ]
);

const selectDataList = (state) => state.creditUsage.data;

const selectFilteredFields = createSelector(
    selectFields,
    (fields) => {
        return fields.map(field => field.id);
    }
);

const selectSort = createSelector(
    (state, props) => state.pages[`credits-usage-report-landing`].sort,
    (sort) => sort || DEFAULT_SORT,
);

const selectFilteredData = createFilteredSortedDataSelector(
    selectFilteredFields,
    (state, props) => state.pages[`credits-usage-report-landing`].filter,
    selectSort,
    selectDataList,
);

const initialDates = () => {
    return {
        beginDate: getStartDate('Last12Months'),
        endDate: getEndDate('Last12Months'),
    }
}

export const CreditsUsageReport = connect(
    () => {
        return (state, props) => ({
            listPending: state.creditUsage.list.pending,
            fields: selectFields(state as never),
            filteredData: selectFilteredData(state, props),
            order: state.pages[`credits-usage-report-landing`].order,
            filter: state.pages[`credits-usage-report-landing`].filter,
            sort: selectSort(state, props),
            initialDates: initialDates,
            downloadReportPending: state.creditUsage.download.pending,
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            creditsUsageReportLanding: creditsUsageReportLanding,
            downloadCreditUsageReport: downloadCreditUsageReport,
            setFilter: (value) => set(`credits-usage-report-landing`, 'filter', value),
            setOrder: (value) => set(`credits-usage-report-landing`, 'order', value),
            setSort: (value) => set(`credits-usage-report-landing`, 'sort', value),
            resetTable: resetCreditUsageReport
        }, dispatch)
    })
)(injectIntl(CreditsUsageReportComponent));